module.exports = __webpack_public_path__ + "static/media/xls.d451c295.png";